import React from 'react'
import BoyWritter from '../../commons/Ilustrations/BoyWritter'
import FeedbackLayout from '../../commons/Layouts/FeedbackLayout'
import styles from './people.module.scss'

export const TITLE = 'Pessoas'
export const SUBTITLE = 'Ainda não existe nenhum consultor contratado'

const PeopleEmpty = () => {
  return (
    <div className={styles.empty}>
      <FeedbackLayout
        center
        title={TITLE}
        subTitle={SUBTITLE}
        Ilustration={() => <BoyWritter />}
      />
    </div>
  )
}

export default React.memo(PeopleEmpty)
